import { useQuery } from '@tanstack/react-query';
import { useAuth0 } from '@auth0/auth0-react';
import { createApiClient } from '../client';

export const usePurchaseOrderPdf = (poNumber: string) => {
  const { getAccessTokenSilently, isAuthenticated } = useAuth0();
  const apiClient = createApiClient(getAccessTokenSilently);

  return useQuery({
    queryKey: ['purchaseOrderPdf', poNumber],
    queryFn: () => apiClient.getPurchaseOrderPdf(poNumber),
    enabled: isAuthenticated && Boolean(poNumber)
  });
};
